import { GameConfig } from '@/config/game';
import classnames from '@/utilities/classnames';
import React from 'react';

export interface SummaryAdditionalGameProps {
  numbers: number[];
  game: GameConfig;
}

const SummaryAdditionalGame: React.FC<
  React.PropsWithChildren<SummaryAdditionalGameProps>
> = ({ numbers, game }) => {
  return (
    <div className="SummaryAdditionalGame">
      {game.label && game.label.imgPath && (
        <img
          className={classnames(
            'SummaryAdditionalGame__logo',
            `SummaryAdditionalGame__logo--${game.shortname}`
          )}
          src={`/assets/images/${game.label.imgPath}`}
          alt={game.label.text}
        />
      )}
      <span className="SummaryAdditionalGame__numbers">
        ({numbers.join('')})
      </span>
    </div>
  );
};

export default SummaryAdditionalGame;
